<template>
    <div v-if="menu.can_edit" class="btn-group">
        <a
            class="dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            href="#"
        >
            <i class="fal fa-bars icon-dropdown"/>
        </a>
        <div class="dropdown-menu">
            <b-link
                class="dropdown-item"
                :href="'actions/' + menu.action_id + '/edit'"
            >
                <span style="padding-right: 5px">
                    <i class="fal fa-fw fa-pencil"/>
                </span
                ><span class="action">Modifier</span>
            </b-link>
            <b-link class="dropdown-item" @click="$refs['deletion-modal'].show()">
                <span style="padding-right: 5px">
                    <i class="fal fa-fw fa-trash-alt"/>
                </span>
                <span class="action">Supprimer</span>
            </b-link>
        </div>
        <b-modal
            ref="deletion-modal"
            hide-footer
            title="Suppression de l'action"
        >
            <p>
                A partir de quand souhaitez-vous supprimer les échéances de cette action ?
            </p>
            <b-input-group class="mb-3">
                <b-form-input
                    id="current-date"
                    v-model="formatted_current_date"
                    type="text"
                    autocomplete="off"
                    disabled
                    class="bg-white"
                />
                <b-input-group-append>
                    <b-form-datepicker
                        v-model="form.from_date"
                        button-only
                        right
                        size="sm"
                        label-no-date-selected="A partir du..."
                        label-prev-year="Année précédente"
                        label-next-year="Année prochaine"
                        label-prev-month="Mois précédent"
                        label-next-month="Mois prochain"
                        label-current-month="Mois actuel"
                        label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                        start-weekday="1"
                        aria-controls="current-date"
                        locale="fr"
                        @context="formatCurrentDate"
                    >
                    </b-form-datepicker>
                </b-input-group-append>
            </b-input-group>
            <b-button
                variant="danger"
                :disabled="form.from_date === null"
                @click="deleteItem"
            >
                Supprimer
            </b-button>
            <b-button variant="secondary" @click="hideModal">
                Annuler
            </b-button>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'DropMenuAction',

    props: {
        menu: Object,
    },

    data() {
        return {
            form: {
                from_date: null,
            },
            formatted_current_date: '',
        }
    },

    computed: {
        editUrl() {
            return `actions/${this.menu.action_id}/edit`
        },
    },

    created() {
        this.form.from_date = new Date()
    },

    methods: {
        showConfirmationModal() {
            this.$bvModal
                .msgBoxConfirm(
                    'Etes vous sûr·e de vouloir supprimer cette action ?',
                    {
                        title: 'Confirmation',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Supprimer',
                        cancelTitle: 'Annuler',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then((value) => {
                    if (value) {
                        this.deleteItem()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        async deleteItem() {
            try {
                await axios.put(
                    `/clientActions/${this.menu.action_id}/delete`,
                    this.form
                )
                this.$root.$refs.clientActionsTable.getItems()
            } catch (error) {
                console.log(error)
            }
        },
        hideModal() {
            this.$refs['deletion-modal'].hide()
        },
        formatCurrentDate(ctx) {
            this.formatted_current_date = ctx.selectedFormatted
        },
    },
}
</script>

<style scoped></style>
